module.exports = __webpack_public_path__ + "static/media/foodndrinks_beach_marker.c5171769.svg";